import {
  ORDER_EVENT_TYPE_META,
  type OrderEventType,
} from '@stopal/shared/order-form'
import { House, PackagePlus, PackageX, Truck, Warehouse } from 'lucide-react'
import type { StatusPresetMap } from './types'

// Single source — the value list/type lives in @stopal/shared; never re-typed here.
export type OrderType = OrderEventType

/** A Stop's role within its Order Event: a move's two stops share one event
 *  type, so they can only be told apart by which visit they are. Single-sourced
 *  in @stopal/shared (the DB enum derives from the same array). */
export type { StopType } from '@stopal/shared/stop-status'

// Ops display presets for the canonical event taxonomy. Label + letter-code come
// from the shared ORDER_EVENT_TYPE_META registry; this surface adds only the
// web-specific bits (tone, icon, hover description).
export const orderEventTypePresets: StatusPresetMap<OrderType> = {
  empty_delivery: {
    label: ORDER_EVENT_TYPE_META.empty_delivery.label,
    tone: 'success',
    code: ORDER_EVENT_TYPE_META.empty_delivery.code,
    icon: PackagePlus,
    description: 'Collapsed CBC units dropped to the customer to pack.',
  },
  full_storage_pickup: {
    label: ORDER_EVENT_TYPE_META.full_storage_pickup.label,
    tone: 'info',
    code: ORDER_EVENT_TYPE_META.full_storage_pickup.code,
    icon: Warehouse,
    description:
      'Packed CBC collected from the customer and carried to the warehouse.',
  },
  full_storage_return: {
    label: ORDER_EVENT_TYPE_META.full_storage_return.label,
    tone: 'progress',
    code: ORDER_EVENT_TYPE_META.full_storage_return.code,
    icon: House,
    description:
      'Packed CBC redelivered from the warehouse back to the customer at the end of the storage term.',
  },
  full_move_delivery: {
    label: ORDER_EVENT_TYPE_META.full_move_delivery.label,
    tone: 'warning',
    code: ORDER_EVENT_TYPE_META.full_move_delivery.code,
    icon: Truck,
    description:
      'Packed CBC transported to the move destination and set down — the loaded orderEvent of a local move.',
  },
  empty_retrieval: {
    label: ORDER_EVENT_TYPE_META.empty_retrieval.label,
    tone: 'critical',
    code: ORDER_EVENT_TYPE_META.empty_retrieval.code,
    icon: PackageX,
    description:
      'Emptied CBC collected from the customer, closing the lifecycle.',
  },
  carrier_move: {
    label: ORDER_EVENT_TYPE_META.carrier_move.label,
    tone: 'muted',
    code: ORDER_EVENT_TYPE_META.carrier_move.code,
    icon: Truck,
    description:
      'Long-distance move fulfilled by a third-party carrier, outside the owned fleet.',
  },
  carrier_empty_retrieval: {
    label: ORDER_EVENT_TYPE_META.carrier_empty_retrieval.label,
    tone: 'muted',
    code: ORDER_EVENT_TYPE_META.carrier_empty_retrieval.code,
    icon: PackageX,
    description:
      'Emptied CBC collected from an out-of-area destination by a third-party carrier, closing a carrier move.',
  },
}
